// removed by extract-text-webpack-plugin
module.exports = {"statistical":"statistical","statistical-left":"statistical-left","statistical-title":"statistical-title","statistical-item":"statistical-item","statistical-item-background":"statistical-item-background","statistical-item-value":"statistical-item-value","statistical-item-name":"statistical-item-name","statistical-right":"statistical-right","statistical-sum-item":"statistical-sum-item","statistical-sum-percent":"statistical-sum-percent","statistical-sum-text":"statistical-sum-text"};


//////////////////
// WEBPACK FOOTER
// ./components/my-business/sub-view/the-news/statistical/style.scss
// module id = ./components/my-business/sub-view/the-news/statistical/style.scss
// module chunks = 0